import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { SkechersSizeEntity } from "../entity/skechers-size-entity";

@Injectable()
export class SizeRepo extends Repository<SkechersSizeEntity> {

    constructor(@InjectRepository(SkechersSizeEntity) private repo: Repository<SkechersSizeEntity>
    ) {
        super(repo.target, repo.manager, repo.queryRunner);
    }
}
